import type { IGlobalState } from '@src/reducers';

export const selectFullDealCalculator = (state: IGlobalState) => state.fullDeal.calculator;
